/**
 * Port of `jQuery.parents()`.
 */
function parents(element, selector) {
  var elements = [];
  var elem = element.parentElement;

  while (elem !== null) {
    if (elem.nodeType === Node.ELEMENT_NODE && elem.matches(selector)) {
      elements.push(elem);
    }

    elem = elem.parentElement;
  }

  return elements;
}

export { parents };